export default "__VITE_PUBLIC_ASSET__3416431e__"